var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/microsoft/icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/microsoft/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7F7F9",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(20.000000, 20.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#F1511B",
  points: "28.510297 28.510297 0 28.510297 0 0 28.510297 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#80CC28",
  points: "59.9888534 28.510297 31.4791001 28.510297 31.4791001 0 59.9888534 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#00ADEF",
  points: "28.5094814 60 0 60 0 31.4899749 28.5094814 31.4899749"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FBBC09",
  points: "59.9888534 60 31.4791001 60 31.4791001 31.4899749 59.9888534 31.4899749"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/square.ed91ebed5cf25190f78bf099279730ed.svg";